export default "__VITE_ASSET__BOZAhSxh__"